import { useMutation } from '@tanstack/react-query';
import { createFormData } from '@/helpers/utils';
import { resizeFile } from '@/utils/image';
import api from '../../services/api';

export type CreateShopProductParams = {
    name: string;
    categoryId: number;
    barCode: string;
    lastPriceInCents: number;
    image?: File;
    imageUrl?: string;
};

const createShopProduct = async ({
    barCode,
    image,
    ...fields
}: CreateShopProductParams): Promise<{ id?: number }> => {
    const data = createFormData({
        ...fields,
        barCodes: [barCode],
        image: image ? await resizeFile(image) : undefined,
    });

    const response = await api.post('product/', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const useCreateShopProduct = () =>
    useMutation({
        mutationFn: createShopProduct,
        retry: false,
    });
